export default __webpack_public_path__ + "static/media/banner-collapse.b08e7605.png";